module.exports = __webpack_public_path__ + "img/pointer_gray.da8c37cd.png";